//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
// eslint-disable-next-line object-curly-newline
import { mdiCheck, mdiClose, mdiAlarm, mdiAlarmCheck, mdiCheckCircle, mdiCloseCircle } from '@mdi/js'

export default {
  setup() {
    const toggleCheckboxOne = ref(true)
    const toggleCheckboxTwo = ref(true)
    const toggleCheckboxThree = ref(true)

    return {
      toggleCheckboxOne,
      toggleCheckboxTwo,
      toggleCheckboxThree,

      // icons
      icons: {
        mdiCheck,
        mdiClose,
        mdiAlarm,
        mdiAlarmCheck,
        mdiCheckCircle,
        mdiCloseCircle,
      },
    }
  },
}
